interface InnerSubMenu {
  title: string;
  link: string;
}

interface SubMenu {
  title: string;
  link: string;
  has_inner_dropdown: boolean;
  submenu?: InnerSubMenu[];
}

interface MenuDataType {
  title: string;
  link: string;
  has_dropdown: boolean;
  submenu?: SubMenu[];
}

const menu_data: MenuDataType[] = [
  {
    title: "الرئيسية",
    link: "/",
    has_dropdown: false,
  },
  {
    title: "من نحن",
    link: "/about-us",
    has_dropdown: false,
  },
  {
    title: "خدماتنا",
    link: "/services",
    has_dropdown: false,
  },
  {
    title: "منتجاتنا",
    link: "/projects",
    has_dropdown: false,
  },
  
];

export default menu_data; 